import { InfoOutlineIcon } from '@carboncopyco/icons';
import { ColorHex, Tooltip, TooltipMessage } from '@carboncopyco/ui';
import { useRef } from 'react';

export type TextReplaceAdvancedSettingsTooltipProps = {
  message: string;
};

export const TextReplaceAdvancedSettingsTooltip = ({
  message,
}: TextReplaceAdvancedSettingsTooltipProps) => {
  const tooltipRef = useRef<HTMLDivElement>();
  return (
    <>
      <div
        role="button"
        ref={tooltipRef}
        className="ml-2"
        aria-label="Show more info"
      >
        <InfoOutlineIcon
          size={20}
          color={ColorHex.natural200}
        />
      </div>
      <Tooltip
        shadow="md"
        noArrow
        placement="bottom"
        anchorRef={tooltipRef}
      >
        <TooltipMessage
          title={message}
          wrapMessage={false}
        />
      </Tooltip>
    </>
  );
};
